import React from "react";
import Navbar from "../../../../components/Navbar/Navbar";
import Banner from "../../../../components/body/topLocationsComponents/locationsComponents/Banner";
import { BannerData, LocationData } from "./data";
import LocationComponentsCard from "../../../../components/body/topLocationsComponents/locationsComponents/LocationComponentsCard ";
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer";
import { allProjectData } from "../../../../data/all_properties/data";
import { filterPropertiesByLocation } from "../../../../components/body/topDevelopersComponents/filterproperty";


const GolfCourseRoad = () => {
  const groupedProperties = filterPropertiesByLocation(
    allProjectData,
    "Golf Course Road"
  );
  return (
    <div>
      <Navbar />
      <Banner BannerData={BannerData} />
      <LocationComponentsCard LocationData={LocationData} />
      <Main_Footer />
    </div>
  );
};

export default GolfCourseRoad;
